import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { NumericFormat } from "react-number-format";
import { Box, Button, Card, CardActions, CardContent, Grid, Typography } from "@mui/material";
import { addExpense, selectExpenseIdsByType, selectExpenseTotalByType } from "./expensesSlice";
import { AddCircle } from "@mui/icons-material";
import { Expense } from "./Expense";

export const Expenses = ({ label, type, headers }) => {
	const dispatch = useDispatch();
	const expenses = useSelector(state => selectExpenseIdsByType(state, type));
	const marginalTotal = useSelector(state => selectExpenseTotalByType(state, {type, field: "marginal"}));
	const fixedTotal = useSelector(state => selectExpenseTotalByType(state, {type, field: "fixed"}));
	const amountTotal = useSelector(state => selectExpenseTotalByType(state, {type, field: "amount"}));
	const totals = [
		...(type !== "fixed" ? [marginalTotal] : []),
		...(type === "mixed" ? [fixedTotal] : []),
		...(type === "fixed" ? [amountTotal] : [])
	]

	const add = () => {
		dispatch(addExpense(type));
	};

	return (
		<Card sx={{height: "100%"}}>
			<CardContent sx={{display: "flex", flexDirection: "column"}}>
				<Typography><b>{label}</b></Typography>
				<Box sx={{width: "100%", py: 2}}>
					<Box sx={{mr: "50px"}}>
						<Grid container spacing={1}>
							<Grid container spacing={1} item>
								{headers.map(({label, xs}, key) =>
									<Grid key={`${type}_expense_header_${key}`} item {...{xs}}>
										<Typography variant="body2" sx={{px: .5, py: 1, textAlign: key > 0 ? "end" : "start", fontSize: ".8rem"}}>
											<b>{label}</b>
										</Typography>
									</Grid>
								)}
							</Grid>
						</Grid>
					</Box>
					<Grid container spacing={1}>
						{expenses.map((id, key) =>
							<Expense key={`${type}_expense_${key}`} {...{id}} />
						)}
					</Grid>
					<Box sx={{pt: 3, width: "100%", display: "flex", justifyContent: "center"}}>
						<Button
							variant="contained"
							color="success"
							onClick={add}
							sx={{
								p: .7,
								display: "flex", alignItems: "center", justifyContent: "center",
								boxShadow: "rgba(46, 125, 50, .2) 0px 0px 10px",
								height: "100%",
								width: "100%",
								borderRadius: 2
							}}
						>
							<AddCircle sx={{mr: 1}} />
							<Typography variant="button">Add New Line Item</Typography>
						</Button>
					</Box>
				</Box>
			</CardContent>
			<CardActions sx={{display: "flex", flexDirection: "column", p: 2}}>
				<Box sx={{width: "100%", borderTop: 1, borderBottom: 1, py: 2, borderColor: "grey.300", pr: "40px"}}>
					<Grid container item xs spacing={1}>
						<Grid item xs={type === "mixed" ? 8 : 10}>
							<Typography sx={{pl: 1.75}}><b>Total:</b></Typography>
						</Grid>
						{totals.map((total, key) =>
							<Grid key={`${type}_total_${key}`} item xs={2}>
								<Typography sx={{textAlign: "end", pr: "16px", fontWeight: "bold"}}>
									<NumericFormat
										value={total}
										prefix="$ "
										displayType="text"
										fixedDecimalScale
										allowLeadingZeros
										thousandSeparator=","
										decimalScale={2}
									/>
								</Typography>
							</Grid>
						)}
					</Grid>
				</Box>
			</CardActions>
		</Card>
	);
};